import { BaseBootConfig, ScaleConfig } from '@scarybeasties/phaser-framework-core/settings';

export const defaultBootConfig: BaseBootConfig = {
  env: __IS_PRODUCTION__ ? 'prod' : 'dev',
  lang: __LANG__,
  bootScene: 'Boot',
  defaultScene: 'Error',
  localStorageKey: __DATA_ID__,
  configFilename: 'config',
  configBasePath: 'assets/json/',
  spineBasePath: 'assets/animations/',
  audioBasePath: 'assets/sounds/',
  jsonBasePath: 'assets/json/',
  localisationsFilename: 'localisations',
  audioFileFormats: ['webm', 'm4a', 'ogg', 'mp3'],
  audioDefaultChannels: [
    {
      name: 'sfx',
      isSingleTrack: false
    },
    {
      name: 'music',
      isSingleTrack: true
    }
  ],
  keyTranslationMap: {
    gsd: 'gameSceneData',
    rs: 'runSettings'
  },
  queryTargetKey: 'target',
  querySceneKey: 'scene'
};

export const defaultScaleConfig: ScaleConfig = {
  canvasWidth: 1920,
  canvasHeight: 768,
  sceneWidth: 1920,
  sceneHeight: 768,
  minWidth: 1200,
  minHeight: 600,
  maxWidth: 1920,
  maxHeight: 768
};

export const defaultGameConfig: Phaser.Types.Core.GameConfig = {
  width: defaultScaleConfig.canvasWidth,
  height: defaultScaleConfig.canvasHeight,
  backgroundColor: '#2f2f2f',
    
  scale: {
    min: {
      width: defaultScaleConfig.minWidth,
      height: defaultScaleConfig.minHeight
    },
    max: {
      width: defaultScaleConfig.maxWidth,
      height: defaultScaleConfig.maxHeight
    },
    zoom: 1,
    parent: 'game',
    fullscreenTarget: 'game'
  },
  loader: {
    localScheme: ['file://', 'capacitor://', 'ionic://']
  },
  physics: {
    default: 'matter',
    matter: {
      debug: !__IS_PRODUCTION__,
      enabled: false
    }
  },
  fps: {
    target: 30
  },
  plugins: {
    scene: [
      {
        key: 'SpinePlugin',
        plugin: window.SpinePlugin,
        mapping: 'spine'
      }
    ]
  }
};
